// extracted by mini-css-extract-plugin
export default {"opted-state":"style_opted-state__zZqQ-","optedState":"style_opted-state__zZqQ-","icon":"style_icon__Iar-W"};